import PropTypes from "prop-types";
import React from "react";
import styled, {css} from "styled-components";
import * as d3 from "d3";

const ChartSlice = ({slice, active = false, showValue = false, showColors = false}) => {
  const {data, radius, innerRadius, startAngle, endAngle} = slice;

  const {themeColor} = data;

  const generator = d3
    .arc()
    .innerRadius(innerRadius)
    .outerRadius(radius)
    .startAngle(startAngle) // Starting angle (in radians)
    .endAngle(endAngle);

  const [x, y] = generator.centroid(data);
  const translate = `translate(${x}, ${y - (showValue ? 10 : 0)})`;
  const translateValue = `translate(${x + (showValue ? 2 : 0)}, ${y + (showValue ? 15 : 0)})`;

  return (
    <>
      <Path d={generator()} active={active} themeColor={themeColor} showColors={showColors} />
      <Text textAnchor="middle" alignmentBaseline="middle" transform={translate}>
        {data.label}
      </Text>
      {showValue && (
        <Text textAnchor="middle" alignmentBaseline="middle" transform={translateValue}>
          {data.value}%
        </Text>
      )}
    </>
  );
};

ChartSlice.propTypes = {
  slice: PropTypes.objectOf(PropTypes.any).isRequired,
  active: PropTypes.bool,
  showValue: PropTypes.bool,
  showColors: PropTypes.bool
};

// Style Overrides
const Path = styled.path`
  fill: ${({active, theme, themeColor}) =>
    active ? theme[themeColor] || theme.primary : theme.secondary};
  stroke: ${({theme}) => theme.tertiary};
  stroke-width: 2;

  ${({showColors, theme, themeColor}) =>
    showColors &&
    css`
      fill: ${theme[themeColor] || theme.primary};
    `}
`;

const Text = styled.text`
  fill: ${({theme}) => theme.tertiary};
`;

export default ChartSlice;
